import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';

@Injectable({
  providedIn: 'root'
})
export abstract class OtpService {

  abstract url: string;

  constructor(
    private appService: AppService
  ) { }

  getMaskedContactInfo(): Observable<any> {
    return this.appService.postRequest(this.url, { action: 'getMaskedContactInfo' });
  }

  sendOtp(sendOTPType: string): Observable<any> {
    return this.appService.postRequest(this.url, { sendOTPType, action: 'sendOTP' });
  }

  validateOTP(otpNum: string): Observable<any> {
    return this.appService.postRequest(this.url, { otpNum, action: 'validateOTP' })
  }

}
